import http from 'services/http-service';

const OrderService = {
    GetListOrder(searchKey: string, status: number, skipCount: number, maxResultCount: number) {
        let response = http.get('/orders/list', { params: { searchKey: searchKey, status: status, skipCount: skipCount, maxResultCount: maxResultCount } });
        return response;
    },

    PayManual(id: string, logosBankAccountId: string, bankAccountName: string, amount: any, isFullPayment: any, screenshot: any) {
        let formData = new FormData();
        formData.append("id", id);
        formData.append("logosBankAccountId", logosBankAccountId);
        //formData.append("bankName", bankName);
        formData.append("bankAccountName", bankAccountName);
        //formData.append("bankAccountNumber", bankAccountNumber);
        formData.append("screenshot", screenshot);
        formData.append("amount", amount);
        formData.append("isFullPayment", isFullPayment);

        var result = http.post("/orders/paymanual", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
        return result;
    },

    Get(orderId: any) {
        let response = http.get(`/orders/${orderId}`);
        return response;
    },

    GetSimpleDto(orderId: string) {
        let response = http.get(`/orders/${orderId}/simple`);
        return response;
    },

    GetByInvoiceNoSimpleDto(invoiceNo: string) {
        let response = http.get(`/orders/invoice/${invoiceNo}/simple`);
        return response;
    },

    GetCurrentUserBillings(skipCount: number, maxResultCount: number) {
        let response = http.get('/orders/billings', { params: { skipCount, maxResultCount } });
        return response;
    }
};

export default OrderService;